import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, watch } from 'vue';
import { useToaster } from '@/composables/toaster';
import CInput from '@/components/shared/CInput';
import CButton from '@/components/shared/CButton/CButton.vue';
import type { VectorPlaceholderElement } from '@/typings/customilyElements/canvasElements';
import type { CanvasEx } from '@/typings/canvas';
import { DEFAULT_QR_DATA, isStyledQrConfig, updateStyledQrOptions } from '@/utils/qrCodeUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'QrCodeTester',
  props: {
    canvas: null,
    vectorElement: null,
    editMode: { type: Boolean }
  },
  emits: ["trigger-loading"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'trigger-loading', isLoading: boolean, msg?: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    canvas: CanvasEx;
    vectorElement?: VectorPlaceholderElement;
    editMode?: boolean;
};





const model = reactive({
    data: DEFAULT_QR_DATA
});

const disabled = computed(() => !!props.vectorElement?.locked);

watch(
    () => props.vectorElement,
    (element) => {
        if (!element || !isStyledQrConfig(element.qrConfig)) return;

        model.data = element.qrConfig.options.data;
    },
    { immediate: true }
);

const toaster = useToaster();
const generateQr = async () => {
    if (!model.data.trim()) return;

    try {
        emit('trigger-loading', true, 'Generating QR code...');
        await updateStyledQrOptions(props.vectorElement, props.canvas, { data: model.data }, props.editMode);
    } catch (error) {
        console.error('Error generating QR code:', error);
        toaster.error('An error occurred while generating the QR code');
    } finally {
        emit('trigger-loading', false);
    }
};

return { __sfc: true,props, emit, model, disabled, toaster, generateQr, CInput, CButton }
}

})